const formatDate = (date) => {
  const isoString = date.toISOString();
  const dateParts = isoString.split('T');

  return `${dateParts[0]} ${dateParts[1].substring(0, 8)}`;
};

export default formatDate;
